import { useTheme } from "@emotion/react";
import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";
import { getTriggerPoint } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import {
  Button,
  ButtonContainer,
  Container,
  Message,
  MessageContainer,
  StyledNewsletterIcon,
  SummaryLine,
} from "./styles";

export type Props = React.DetailsHTMLAttributes<HTMLDivElement>;

export const FindOutMore: React.FunctionComponent<Props> = ({ ...props }) => {
  const { handleRoutePush, handleTrackGA4 } = useSdkContext();
  const { campaignName, findOutMoreButtonDisplayComponent, variant } = useNewsletterContext();
  const theme = useTheme() as unknown as ThemeType;
  return (
    <Container {...props}>
      {theme?.hasSummaryLine && <SummaryLine />}
      <StyledNewsletterIcon />
      <MessageContainer>
        <Message>Sign up for our Newsletters</Message>
      </MessageContainer>
      <ButtonContainer>
        <Button
          href="/newsletters"
          onClick={event => {
            event.preventDefault();
            handleTrackGA4({
              action: "click",
              category: "nl",
              customized_parameters: {
                internal_campaign: campaignName ?? "",
                trigger_point: getTriggerPoint(variant),
              },
              subcategory: "entry",
            });
            void handleRoutePush("/newsletters");
          }}
        >
          {findOutMoreButtonDisplayComponent ?? "Find out more"}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

FindOutMore.displayName = "FindOutMore";
